import './EventsScreen.css';
import PageHero from '../../components/PageHero';
import EventCard from '../../components/EventCard';
import { useEvents } from './hooks/useEvents';
import { LoadingState, ErrorState } from '../../components';

function EventsScreen() {
  const {
    events,
    loading,
    error,
    currentPage,
    paginationInfo,
    handleNextPage,
    handlePreviousPage,
    retry
  } = useEvents();

  const onNextPage = () => {
    handleNextPage();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onPreviousPage = () => {
    handlePreviousPage();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="events-screen">
      <PageHero 
        title="I Nostri Eventi"
        subtitle="Partecipa alle nostre attività e iniziative"
      />

      <section className="events-content">
        {loading && <LoadingState message="Caricamento eventi..." />}

        {error && <ErrorState message={error} onRetry={retry} />}

        {!loading && !error && events.length === 0 && (
          <div className="empty-state">
            <p>Nessun evento disponibile al momento.</p>
          </div>
        )}

        {!loading && !error && events.length > 0 && (
          <>
            <div className="events-grid">
              {events.map(event => (
                <EventCard
                  key={event.id}
                  id={event.id}
                  title={event.title}
                  date={event.date}
                  time={event.time}
                  location={event.location}
                  description={event.description}
                  imageUrl={event.photo_link}
                  endDate={event.date_end}
                />
              ))}
            </div>

            {paginationInfo && paginationInfo.totalPages > 1 && (
              <div className="pagination">
                <button 
                  onClick={onPreviousPage}
                  disabled={!paginationInfo.hasPreviousPage}
                  className="pagination-btn"
                >
                  Precedente
                </button>
                <span className="pagination-info">
                  Pagina {currentPage + 1} di {paginationInfo.totalPages}
                </span>
                <button 
                  onClick={onNextPage}
                  disabled={!paginationInfo.hasNextPage}
                  className="pagination-btn"
                >
                  Successiva
                </button>
              </div>
            )}
          </>
        )}
      </section>
    </div>
  );
}

export default EventsScreen;
